import React from "react";
import DetailViewCancelButton from "../DetailViewCancelButton";
import DetailViewToolbarMoreActions from "./DetailViewToolbarMoreActions";

interface DocumentDetailViewToolbarProps {
  children?: React.ReactNode;
}

const DocumentDetailViewToolbar: React.FC<DocumentDetailViewToolbarProps> = ({ children }) => {
  const childrenArray = React.Children.toArray(children);

  const nonCancelButtonChildren = childrenArray.filter((child) => {
    return React.isValidElement(child) && child.type !== DetailViewCancelButton && child.type !== DetailViewToolbarMoreActions;
  });

  const cancelButtonChild = childrenArray.find((child) => {
    return React.isValidElement(child) && child.type === DetailViewCancelButton;
  });
  const importExportButtonChild = childrenArray.find((child) => {
    return React.isValidElement(child) && child.type === DetailViewToolbarMoreActions;
  });

  return (
    <div className="d-flex justify-content-between mb-3 mt-2 custom-toolbar">
      <div className="d-flex gap-2 custom-toolbar-left">{nonCancelButtonChildren}</div>
      <div className="d-flex custom-toolbar-right">
        <div>{cancelButtonChild}</div>
        <div>{importExportButtonChild}</div>
      </div>
    </div>
  );
};

export default DocumentDetailViewToolbar;
